import { FC } from 'react'
import { UserImage, UserImageId } from 'interfaces/userImage'
import AdjustableImage from 'components/features/pfm/AdjustableImage/AdjustableImage'
import styles from 'components/features/insights/InsightPostAvatar/InsightPostAvatar.styl'
import { userImagesCollectionSelector } from 'selectors/userImagesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { getItemFromCollection } from 'helpers/normalizeHelpers'

type InsightPostAvatarProps = {
  avatarId: UserImageId | null
}

export const InsightPostAvatar: FC<InsightPostAvatarProps> = (props) => {
  const { avatarId } = props
  const avatar = useStoreSelector((state) => {
    if (!avatarId) {
      return null
    }

    const userImages = userImagesCollectionSelector(state)
    return getItemFromCollection<UserImage, 'id'>(userImages, avatarId)
  })

  if (!avatar) {
    return null
  }
  return (
    <div className={ styles.content }>
      <AdjustableImage
        preventLazyRender
        image={ avatar.image }
        fitToContainer
      />
    </div>
  )
}
